import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchAvLibraryMarcRegPageLoadResult,
  BatchAvLibraryMarcRegPageLoadResultFromJSON
} from '@/api/models/batch/BatchAvLibraryMarcRegPageLoadResult'
import {
  BatchAvLibraryMarcRegRequest,
  BatchAvLibraryMarcRegRequestToJSON
} from '@/api/models/batch/BatchAvLibraryMarcRegRequest'

export class BatchAvLibraryMarcRegApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchAvLibraryMarcRegPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchAvLibraryMarcRegPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createAvLibraryMarcRegist(
    request: BatchAvLibraryMarcRegRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/regist-av-library-marc`,
      BatchAvLibraryMarcRegRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
